import client from './client';

export async function list(params = {}) { const { data } = await client.get('/api/sites', { params }); return data; }
export async function get(id)           { const { data } = await client.get(`/api/sites/${id}`);  return data; }
export async function create(body)      { const { data } = await client.post('/api/sites', body); return data; }
export async function update(id, body)  { const { data } = await client.put(`/api/sites/${id}`, body); return data; }
export async function remove(id)        { const { data } = await client.delete(`/api/sites/${id}`); return data; }
